import { NgCopyButton } from './buttons/NgCopyButton';

export type ReadOnlyValueProps = {
  value?: string;
  isLoading?: boolean;
  allowCopyButton?: boolean;
};

export function ReadOnlyValue({ value, isLoading, allowCopyButton }: ReadOnlyValueProps) {
  return (
    <div className="d-flex justify-content-between align-items-center gap-2 bg-dark bg-opacity-10 p-1">
      <span
        className="flex-grow-1 ps-1"
        style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
      >
        {value}
      </span>

      {isLoading ? (
        <div
          className="spinner-border spinner-border-sm opacity-50"
          style={{ margin: '.46rem' }}
          role="status"
        >
          <span className="visually-hidden"> Loading...</span>
        </div>
      ) : allowCopyButton ? (
        <NgCopyButton valueToCopy={value} type="link" />
      ) : null}
    </div>
  );
}
